module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "CN",
    attrs: {
      "id": "_idParaDest-6"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('span', {
    staticClass: "FinaHyphen"
  }, [_vm._v("-")]), _vm._v(" CHAPTER 3 "), _c('span', {
    staticClass: "FinaHyphen"
  }, [_vm._v("-")])])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "COT"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("D")]), _vm._v("aisy decided we should welcome the young doctor with a curry. She had the wheels put back on the Austin and went to Oxford in search of mango chutney. I offered to help my mother in the kitchen because Maud on the previous day had, on doctor’s orders, given in her notice.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Growing up, I’d seen my mother make the usual ration stodge—rissoles, boiled cabbage, suet puddings—but making curry had a whiff of something secret and special about it, because it only ever happened when we were on our own. Then my mother would get out a battered green tin, uncork the small bottles inside it, and with a finicky, witchy kind of precision that thrilled me, measure out the five or six spices she used. I was under strict instructions never to touch the tin, which she kept in one of the side pockets of her suitcase, or the spices inside them, or to talk about them. When the curry was cooked, she would eat it in a kind of trance, her eyes half-closed, very quiet.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("But this morning, the old magic wasn’t working. Her spine looked rigid as she lashed herself into her apron, a frown line like a sharpened blade between her eyebrows.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I’ll do that, Mummy,” I said, seeing a pile of onions and muddy carrots on the draining board. I took an onion and started to chop it, but she snatched the knife from my hand.")])]), _c('p', {
    staticClass: "TX"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("“Not like that, like this.” Her hand flew down the onion in a blur. “There.” She scooped up the tiny pieces, hurled them into the ")]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("large frying pan, made them sizzle, the air turned blue and for a second, there she was again: my sorceress, my magician.")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "TX"
  }, [_vm._v("Daisy had brought her own spice box home from India, a carved wooden box with rows of tiny cupboards inside, each one filled with a different spice. My mother opened it now and sniffed.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Musty,” she said with an exasperated sigh.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Tell me what they are,” I said, still hoping for a bit of fun with her.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“This is chili powder, very hot. Fennel seeds, chili, dried coriander. I won’t put that in, Ci Ci will complain of indigestion. I’ll use Daisy’s for the chicken curry, and mine for the vegetable. So . . .” She was lost for a moment, her voice lilting, leaning over the onions that had started to turn brown at the edges. “I put spices first, warm them nicely, now lentils.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Get out! Go away!” Her sudden shout made me jump. It was Sid, Daisy’s old black Labrador; he was circling and about to flop in his usual place in front of the Rayburn when she kicked him.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“No dogs in the kitchen!” she shouted.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Keep your hair on, Mummy.” I was softhearted about animals. “He’s not the Loch Ness monster.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Dogs are full of germs and fleas,” she told me after I’d shut him in the freezing hall.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Now here, come close.” She added a teaspoon of coriander to the lentils. “These first,” she whispered, “now the other vegetables.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("And soon it was all lovely in there, with the kitchen filled with smells piquant and strange, the fat hissing, windows steaming, and us absorbed and getting on again. I was accustomed to watching my mother as anxiously as a farmer observes the sky for signs of storms approaching, but now, almost in spite of herself, I saw her whole body soften and relax.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Stir it clockwise,” she told me, stroking my hand. “Counterclockwise is bad luck.”")])]), _c('p', {
    staticClass: "TX"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("My mother had a number of strange beliefs like this: don’t wash ")]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("your hair on a Thursday, never shave your armpits on a Monday—things that when she was in a good mood, I could tease her about.")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('p', {
    staticClass: "TX"
  }, [_vm._v("“Um.” I closed my eyes, glad to feel the touch of her hand. “I love these smells.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Does Tudor like curry?” she asked out of the blue and with a sly look I recoiled from.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“How should I know?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You should make it your business to know.” She dropped my hand. “Because men appreciate these things, and you should wear a dress at night and stop wearing those awful gloves, like some farm laborer, and have you told him about your job?” I had the sense these reproaches had been dangerously backing up, and now they burst out like steam from a geyser.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“My job!” I put down the spoon and sat down. “Why would I talk to him about it?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Well, Daisy has, because he’s mentioned it to me, and by the way, he thinks her charity is madness when the farm is so run-down, but anyway . . .” She’d said what she’d been building up to and now she continued in her wheedly voice, “Let’s not have a row about it.” She lifted a scrawny chicken from the saucepan. “Let it cool, take the flesh off it, chop it small.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("But my blood was up. “Why are you so ashamed of it?” Meaning the midwifery training. “Why do you hate it so much?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Because . . .” Her hand was on the steaming carcass, water streaming from its bottom. “Most men hate that sort of thing, they find it squelchy.” In another, better mood, I might have laughed. However infuriating she could be, I loved my mother’s odd turns of phrase: “she’s gone all bendy,” for a friend who was trying to be feminine and seductive; “I’m forky today,” for when she was cross. Today, I wanted to crown her.")])]), _c('p', {
    staticClass: "TX"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("“And I’m just so happy,” my mother went on in her crooning-mummy voice, stirring and sniffing, “to see my lovely daughter looking healthier. That’s all. I was terribly worried about you ")]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("before. God knows what would have happened if the matron hadn’t phoned.”")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "TX"
  }, [_vm._v("I chopped the chicken and tried to smile. My night sweats, the insomnia, the bouts of weeping I’d tried to pass off as the after­effects of the flu that had swept through our dormitory, but Matron Smythe, my no-nonsense superior at Saint Andrew’s, had described my inability to get out of bed one morning as “a perfectly ordinary case of nervous exhaustion brought on by overwork and the war.” Fourteen-hour shifts and sleepless nights had clobbered quite a few of her girls, she said.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("A dash of rain fell against the window. Ma’s dark eyes filled with tears. “Please, darling,” she said, “let’s not talk about this anymore, it only makes us both unhappy. Soak the rice, and we’ll sit down with a cup of tea, and I’ll try and think what on earth we’re going to do next. We can’t stay here indefinitely, and honestly,” in a fresh spurt of indignation, “is it really such a crime to want to see you settled and happy?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("We drank the tea, and when she was breathing normally again she pulled a copy of "), _c('span', {
    staticClass: "Italic"
  }, [_vm._v("Horse and Hound")]), _vm._v(" from her knitting bag and began the obsessive routine I remembered from childhood. The varnished nail skidded over the results for jumping competitions and advertisements for country homes, which, she observed with relish, no one could afford to heat now, stopping at the classified sections at the back that were her employment exchange.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Hampshire landowner needs housekeeper to run home and do errands, walk dogs, et cetera,” she read aloud.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“No good,” I said. “Woofers.” She had a deep conviction that dogs were filthy and full of disease. She was frightened of them too, even ones she knew.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Elderly widower, Derbyshire, desperately seeks all-round factotum to help run house and do accounts for small farm, and help with entertaining. No pets, small self-contained flat. Time wasters need not apply.”")])]), _c('p', {
    staticClass: "TX"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("She made a small mark with her pencil. In her glory days, she’d worked as the assistant to some big cheese in Indian royalty, the nabob of somewhere or other. And oh! the balls, the polo, the fun.")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('p', {
    staticClass: "TX"
  }, [_vm._v("Poor Mummy. My bad mood collapsed at the sight of her hunched over her magazine, her expression both hopeful and cynical. She was circling a couple of advertisements when Ci Ci’s face appeared around the door, her expression stagily dramatic.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Oh, the bliss of curry.” She closed her eyes. “It does takes one back.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Keep the dog out,” my mother said curtly. “Nosy bloody woman,” she added when the door closed. My spirits sank. Nothing seemed to work anymore, not cooking curry, not being with me, and it felt in that bleak moment that we were trapped in a duet that had once been sweet but now played nothing but duff notes. The spice tin went back in her handbag; I cleaned the countertops. So, no magic wand and maybe she was thinking the same thing. When I looked up, her mouth was struggling.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Don’t say anything,” she said fiercely.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Is it the onions?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Yes, it’s the onions.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("She wiped her eyes on her apron and went to the sink.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You hate this, don’t you?” I said at last.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Don’t talk for a bit.” She kept her head down. “And don’t feel sorry for me.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I watched her dabbing her eyes and patches of white forming on her cheeks, a sure sign of her strongest emotions, and I disliked myself intensely.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Would you want this?” She was splashing her eyes with water. “Doing this?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I like watching you cook,” I said, but only to soothe her, because I knew in a moment of absolute certainty that I must not end up like this: angry and unsatisfied, dependent on the kindness of strangers.")])]), _c('p', {
    staticClass: "TX"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("“Oh, fruit pie” (one of her swear words), “the flipping Rayburn ")]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("is low again.” My mother sank to her knees. “It will take ages to boil the rice when he comes, and take those awful gloves off.”")])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('p', {
    staticClass: "TX"
  }, [_vm._v("“Oh, for God’s sake, Mummy. It’s cold in here.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Then don’t hang around in the kitchen if you’re cold.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I thought it would be fun to cook with you.” I was more upset than the occasion warranted but I couldn’t stop myself.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Well, it’s not fun,” she said, a wild look in her eye. “And for your information I hate making it.” She was back at the sink, washing her hands like Lady Macbeth. “I hate the smell of it, the fiddle of it, and now, with the nig-nog coming, I’m going to have to make it all the time.”")]), _vm._v(" "), _c('p', {
    staticClass: "TXB_Bottom"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "TXF"
  }, [_vm._v("The ugly phrase echoed in my mind all afternoon. It mingled with the smell of spices that spread so tantalizingly throughout the house and over tea, taken as usual in the threadbare sitting room.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Ci Ci, hunched on a sagging sofa near the fire, sneered at the Indian doctor’s qualifications. “Some of them make it up, you know.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Through a mouthful of jam sandwich, she told Tudor and Flora that she, personally, would rather die than set foot in an Indian hospital. Her beady eyes, glaring at us over the rim of her “special teacup,” were those of a disheveled old parrot forced to share its perch. “Does anyone even know which lavatory he’ll use?” Ci Ci said, as if there were dozens of WCs throughout the house. There were actually two, one on her floor, one on ours. “Some of them don’t even know how to use the lav, you know. They squat over the bowl like campers.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Flora closed her eyes. “Mummy.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Flora, you haven’t lived there. I have. Twenty-two years.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Twenty-two years what?” Daisy appeared, showing no sign of having overheard this unpleasant exchange. “Any more tea in that pot?”")])]), _c('p', {
    staticClass: "TX"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("“In India. Some of our servants were quite wonderful,” Ci Ci improvised quickly. Daisy had reminded us firmly at breakfast that ")]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("Anto Thekkeden was a clever young man from a distinguished family. He would be a huge asset to the charity and she would appreciate it if we would all make him very welcome.")])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('p', {
    staticClass: "TX"
  }, [_vm._v("“Pandit ran our house like clockwork,” Ci Ci continued with a sneaky smile to Flora.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Tell them about the Daimler, Mummy,” said Flora, who was a useful prompt when the occasion demanded it.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Oh yes, our lovely, lovely car,” Ci Ci told Tudor, who was looking blankly at her. “Pandit worshipped the thing. Couldn’t stop polishing it, put lovely fresh mints in the glove box. I—” A knock at the door interrupted her.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Maud’s husband, Dave, stood there, breathless and important.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Miss Barker, sorry to trouble you, but a young colored gentleman has fallen in the ditch. He come on a motorbike, skidded, and fell there. Do you want him at the house? He’s approaching it now.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Did you leave him in the ditch?” Daisy sprang from her seat.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“No, ma’am, I—”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“In the snow!” Daisy was appalled.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“No, I just didn’t know if you’d want him up at the house like.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Oh for heaven’s sake, of course we want him in the house,” Daisy snapped. “Get a torch, and I’ll come with you.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Glory,” she said, “go upstairs quickly and check the bathroom is presentable. He’ll be sopping wet and need a bath before supper. Honestly.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("She sent me to the barn to finish sending invitations to a talk she was giving the following week titled “Infant Mortality in India.” I was licking envelopes when I heard the throaty roar of a motorbike coming up the drive, the skid of brakes, and then the front door open and close as the new arrival walked in.")])]), _c('p', {
    staticClass: "TX"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("It was dark by the time I’d finished up the letters. I took a hay net down to Bert the demob horse, then walked back up the drive. When I got back to my room, I saw that my mother had put a blue dress on the bed for me, a pair of pearl earrings beside it. I ")]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("was struggling with their clips when the lights went out. Melting snow down in the valley, Daisy had warned us; happened every year. As I felt my way downstairs, step by step, I could hear the splash of the Indian doctor having his bath upstairs. Daisy was on her hands and knees downstairs, getting oil lamps from the cupboard in the hall.")])]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('p', {
    staticClass: "TX"
  }, [_vm._v("We lit about ten of them and placed them at strategic points around the house. Golden light pooled around the portraits of the frock-coated ancestors in the hall and gave them a startling intimacy. It bounced off the glass eyes of the stuffed foxes, the eagle bagged near Pondicherry. Glory was frightened of the dark, so I went into the kitchen to help her. She was standing motionless beside the battery of small dishes she’d prepared to go with the curry.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Oh, Mater,” I said, “this smells nose-toddlingly good.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("It had been our joke once to speak like this when the lights failed and pretend we were toffs in a Georgette Heyer novel, not tweenies (between-stairs people). Tonight she wouldn’t play.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“It’s all gone wrong.” The whites of her eyes showed through the gloom. “No grated coconut, no fresh mango, no fresh tomatoes: I’m fed up with rationing.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("She plonked a dish of dried-up raisins on the plate, and the WI green apple chutney, which Daisy had found in a cupboard under the sink, having drawn a blank in Oxford.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Is he here?” she said. “Have you seen him?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“He’s having a bath,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“In Ci Ci’s bathroom?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Oh my God.” She closed her eyes. “This is going to be awful.”")]), _vm._v(" "), _c('p', {
    staticClass: "TXB_Bottom"
  }, [_vm._v("* * *")])]), _c('p', {
    staticClass: "TXF"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("We’d set the table with white linen napkins, the good plates, and what was left of the Waterford crystal. Did I say that Daisy had ")]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("bought a beautiful cedar table in India and shipped it home? Terribly impractical, but it looked lovely that night polished to a high conker-colored shine. I think it was Daisy who told me once that you never regret your extravagancies, and this had been one of hers, and it always raised my spirits to see it.")])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('p', {
    staticClass: "TX"
  }, [_vm._v("When we walked in with the trays, Ci Ci, Flora, Daisy, and Tudor were blurred figures in the candlelight. My first sighting of him was as a vague silhouette against a dark door, and when I got closer, a slim man in a too-large jacket that looked peculiar on him, like a boy wearing his father’s clothes. His face was in shadow. Daisy leapt towards him.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Everybody.” She looked down the table towards us. “I have the greatest pleasure in introducing you all.” She pointed to us each in turn and said our names. “And this,” she concluded with a drumroll inflection to her voice, “is Dr. Anto Thekkeden, from South India.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“And more recently, from a ditch near Whitney,” he said. His voice was cultivated, Home Counties clipped, with just a faintly buttery undertone, a purring of the "), _c('span', {
    staticClass: "Italic"
  }, [_vm._v("r")]), _vm._v("s that sounded foreign. I was surprised by it, expecting the Indian singsong that Tudor had done as a turn before he arrived.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("We laughed politely.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“That corner is a brute,” said Daisy. “What kind of motorbike do you drive?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“It’s a Norton, twin cylinder. Very old, and the tires are bald.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“But frightfully economical on petrol, I expect.” Flora was determined to be kind, or maybe to head off Ci Ci, who’d been muttering about hotels again.")])]), _c('p', {
    staticClass: "TX"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("Anto sat between Tudor and Flora. I was opposite him. The fuzzy light from the candles meant I couldn’t see him clearly at first, but when the light suddenly bloomed, oh Lord, he was handsome: high, dignified cheekbones, a wide and tender-looking mouth, and pale cinnamon-colored skin that made him look more like a Spanish grandee than an Indian. The other striking thing ")]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("was his eyes: wide-set and almond-shaped and green, and at this moment, expressing a polite, faintly quizzical, watchful interest in the proceedings.")])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('p', {
    staticClass: "TX"
  }, [_vm._v("Daisy had asked me earlier to get the conversational ball rolling.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I’m Kit,” I said, flustered enough to forget we’d been introduced.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I’m Anto,” he said, as if we hadn’t. He stretched his hand across the table and I shook it.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“And you know Mrs. Mallinson,” I said to show I wasn’t a complete idiot.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Delighted to meet you,” Ci Ci drawled at her most patrician. She’d put on lots of eye makeup, and her silk jacket had a small cigarette burn on the lapel.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“It’s a pleasure to meet you all,” he said softly.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Yes, a Spanish grandee, I thought, without the faintest idea really of what a grandee looked like, except from the pages of "), _c('span', {
    staticClass: "Italic"
  }, [_vm._v("The Spanish Bride")]), _vm._v(". And off-puttingly good-looking, my thoughts ran on: unfair and unnecessary for a man to have cheekbones like that and those eyes. Josie and I had a theory about all good-looking men, based on one or two God’s-gift-to-women doctors we’d met at the hospital: they were shallow and unreliable, and vain, and usually not very bright. To be handsome was like earning interest on money you hadn’t earned in the first place.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Glory has made this in your honor.” Daisy put a steaming plate of chicken and vegetable curry in front of him. “No luck, sadly, with the mango chutney, but this is rather good.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Thank you.” He took the plate, closed his eyes, and breathed in deeply. “I haven’t had this for years.” For a moment he looked so troubled I wondered if we’d got it wrong and he was a strict vegetarian like some of the other Indians I’d read about.")])]), _c('p', {
    staticClass: "TX"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("My mother appeared, dressed for defiance in a green satin shift with jade earrings. "), _c('span', {
    staticClass: "Italic"
  }, [_vm._v("Family friend")]), _vm._v(", her outfit signaled, "), _c('span', {
    staticClass: "Italic"
  }, [_vm._v("not servant")]), _vm._v(". She spooned rice and the lentil dish onto her plate with her usual ")]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("slightly finicky delicacy and then looked around the table, where there was a sudden uneasy pause.")])]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('p', {
    staticClass: "TX"
  }, [_vm._v("“So, Dr. Thekkeden,” Ci Ci said at last, her head at an ironical angle. “What brings you to our shores?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He put down his knife and fork and looked at her. “I’ve been here for ages,” he said in his soft, posh voice. “I was educated here.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Ah! So that’s why you speak good English.” Ci Ci was quite the Bombay hostess again. “Do have some more of this rather peculiar chutney.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“What school?” Tudor looked up.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Downside.” His reply was clipped. “My parents are Catholic.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Oh.” Tudor sounded surprised. “Is that unusual?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“The school or the religion?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Well, both.” Tudor was sounding prickly.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“It is most unusual,” the young doctor confirmed. “But my father loves all things English.” There was a dry note in his voice as he said this, something a little mocking and public schooly. “He would wear plus fours if it wasn’t so hot in South India.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“And what profession does he follow?” asked Ci Ci.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“He is a lawyer. He was called to the bar at Lincoln’s Inn.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Am I correct in thinking Gandhi practiced law in England too?” Tudor asked. “Before he took up spinning and good works?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Stop peppering the poor man with questions, I thought.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Gandhi was called to the bar at Grey’s Inn,” Daisy jumped in. “But he never practiced here. I met him once, you know, in Bombay, where we ran a children’s home. He was a great man.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“A great man,” the Indian doctor confirmed quietly. “I’ve been reading about him in the papers.” I noticed the cuffs on his jacket were frayed.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Would you like some more rice?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I would.” He looked at me across the table. “Thank you.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I walked to the sideboard, where the food was kept warm on a small steel tray with three candles underneath it.")])]), _c('p', {
    staticClass: "TX"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("“Sit down.” My mother spoke for the first time. “I’ll do it. Our maid has the flu,” she explained briefly to Anto. “It’s a real bore.”")])]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('p', {
    staticClass: "TX"
  }, [_vm._v("“The food is very good,” he told her. “Thank you.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I saw her considering whether to tell him about her job in India now or later. The governor, the picnics, the polo games.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("But Flora said, “So did you get stuck here during the war?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Sort of,” he replied.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Stuck here!” Ci Ci’s voice held a note of muted outrage. It was all right for her to hate England, but it was cheek for an Indian.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“My father was keen for me to do my medical training at Bart’s Hospital, and then the war came. I haven’t been home for nine years.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“So you’re practically one of us,” said Daisy.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He didn’t answer, just a little smile.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Did you mind?” Flora asked. She was wide-eyed like a child.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He put down his fork and stopped eating. “That’s a big question,” he said. “None of us expected the war.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Will you go home soon?” Daisy asked.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“That is the plan.” He looked at her directly with his long-lashed green eyes and gave an almost smile. “I’m worried they won’t recognize me. And may I ask about you?” He addressed the table generally.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Oh, us.” Ci Ci’s lip furled backwards, showing her sharp little teeth. “Oh, we’re Empire flotsam and jetsam.” She laughed to show this was a charming and self-deprecating joke. “We’re renting here while we catch our breath.” After a sip of Daisy’s surprisingly potent elderflower wine, she rambled on at length about the Daimler and Godfrey’s factory. How India had taken years off Godfrey’s life, and how Gandhi had spoiled things by stirring people up.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Sorry about this,”—she flung a defiant look around the table—“but I personally thought he was a ghastly little man, sitting there spinning in his nappy.”")])]), _c('p', {
    staticClass: "TX"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("Daisy was shaking her head as if to say, Stop stop, stop! but said ")]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("nothing, not wanting, I imagine, to stir up any storm clouds on his first day.")])]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('p', {
    staticClass: "TX"
  }, [_vm._v("“Just a tiny bit more, dear.” When Ci Ci held her glass towards Tudor, I stood up.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Would you like me to show you your room?” I said to the doctor. “It’s on the first floor.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("My mother shot me a look of pure venom.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“What a splendid idea.” Daisy looked relieved. “There was only time for a bath before dinner.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Thank you,” he said, “I’d like that.” And to Daisy, and my mother: “A delicious meal. I can’t thank you enough. I look forward to seeing you all tomorrow.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("As we left the room, the door releasing an icy draft, Ci Ci Mallinson said quite audibly, “Well, he’s got quite good table manners: that’s something, I suppose.”")])])]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14911a02","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch03.vue
// module id = 78
// module chunks = 0